import api from "@/api";

/**
 * Handles the POST to /api/modal/promotion-popup/capture for the
 * e-mail method of the Promo Popup (Sistema #1). Thin wrapper around
 * the API client that normalizes success/error shapes — mirrors the
 * Saída do Assine capture composable so both features follow the same
 * contract.
 */
export function usePromotionPopupCapture() {
  async function submit(payload: {
    promotion_popup_id: number;
    email: string;
    locale: string;
    consent: boolean;
    website?: string;
  }) {
    try {
      const { data } = await api.post("modal/promotion-popup/capture", {
        promotion_popup_id: payload.promotion_popup_id,
        email: payload.email,
        locale: payload.locale,
        consent: payload.consent,
        website: payload.website ?? "",
      });
      return {
        ok: Boolean(data?.ok),
        message: data?.message ?? "",
        status: data?.status ?? "",
      };
    } catch (err: any) {
      const resp = err?.response?.data;
      return {
        ok: false,
        message: resp?.message ?? "Não foi possível enviar.",
        status: resp?.status ?? "error",
      };
    }
  }

  return { submit };
}
